import ExtendableError from 'es6-error';
import { isError } from './isErrorLike';
export class CustomError extends ExtendableError {
    constructor(name, message, originalError) {
        super(message);
        this.originalError = originalError;
        this.name = name;
        if (isError(originalError)) {
            this.stack = originalError.stack;
        }
    }
}
//# sourceMappingURL=customError.js.map